
  <br>
  <div class="d-flex justify-content-between me-4 ms-2" style="height:95vh;">
    <div style="height:600px;">
      <p class="rubrik">Systembehörigheter</p>
      <!--button
  pButton
  type="button"
  label="Exportera till Excel"
  icon="pi pi-file-excel"
  class="p-button-success mb-3"
  (click)="loadAllRolesPermissions()">
</button-->
      <p-listbox [options]="roles" (onChange)="viewAccess($event)" [(ngModel)]="selectedrole" optionLabel="label" [listStyle]="{'width': '100%', 'min-height':'600px', 'font-weight':'bold'}">
      </p-listbox>
    </div>
    <div>
      <div>
        <p><b style="text-transform: uppercase;">{{selectedrole?.label}}</b></p>
      </div>
      <div *ngIf="selectedrole" class="p-grid" style="margin-bottom:10px;overflow-y:auto;">
        <div *ngFor="let p of selectedPermissions">
          <mat-expansion-panel *ngIf="selectedrole">
            <mat-expansion-panel-header [expandedHeight]="'38px'" [collapsedHeight]="'38px'">
              <mat-panel-title>
                {{p.category}}
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <table *ngFor="let permission of p.permissions">
              <tr>
                <td>
                  <mat-checkbox [value]="permission" [checked]="permission.isActive" (change)="updatePermission($event)">
                    {{permission.description}}</mat-checkbox>
                </td>
              </tr>
            </table>
          </mat-expansion-panel>
        </div>
      </div>
    </div>
    <div style="border:1px solid lightgrey;height:600px;">
      <table class="table table-bordered">
        <tr style="background: ligthgrey;">
          <th>Systembehörigheter</th>
          <th>Behörighetsroll</th>
        </tr>
        <tr>
          <td>Systemadministratör</td>
          <td>Systemadministratör</td>
        </tr>
        <tr>
          <td>Administratör central</td>
          <td>Administratör - kansliet</td>
        </tr>
        <tr>
          <td>Administratör Loge</td>
          <td>Protokollsekreterare - loge</td>
        </tr>
        <tr>
          <td>Administratör Övrig</td>
          <td>Protokollförare - läger<br>
            Administratör - förening
          </td>
        </tr>
        <tr>
          <td>Administratör Avgifter</td>
          <td>
            Finanssekreterare - loge<br>
            Räkenskapsförare - läger<br>
            Finanssekreterare - förening
          </td>
        </tr>
        <tr>
          <td>Unika ämbeten</td>
          <td>Unika ämbeten - Storlogen</td>
        </tr>
        <tr>
          <td>Valämbetsman</td>
          <td>
            Valämbetsman - loge<br>
            Valämbetsman - läger<br>
            Valämbetsman - förening
          </td>
        </tr>
        <tr>
          <td>Revisor</td>
          <td>
            Revisor - Storlogen<br>
            Revisor - loge<br>
            Revisor - läger
          </td>
        </tr>
        <tr>
          <td>Medlem</td>
          <td>
            Medlem - Loge<br>
            Medlem - läger<br>
            Medlem - förening
          </td>
        </tr>
      </table>
    </div>
  </div>
